(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  function initializeProductNewsletterPopups(root = document) {
    root.querySelectorAll('[data-product-newsletter-popup]').forEach((popup) => {
      if (popup.dataset.initialized === 'true') return;

      const storageKey = popup.dataset.storageKey;
      const frequencyMilliseconds = Number(popup.dataset.frequencyDays) * 24 * 60 * 60 * 1000;
      const lastClosed = Number(localStorage.getItem(storageKey) || 0);
      const successMessage = popup.querySelector('[data-product-newsletter-success]');
      const isThemeEditor = window.Shopify && window.Shopify.designMode;

      const openPopup = () => {
        if (!popup.open) popup.showModal();
      };

      const closePopup = () => {
        localStorage.setItem(storageKey, String(Date.now()));
        popup.close();
      };

      popup.querySelector('[data-product-newsletter-close]')?.addEventListener('click', closePopup);
      popup.addEventListener('click', (event) => {
        if (event.target === popup) closePopup();
      });
      popup.addEventListener('cancel', () => {
        localStorage.setItem(storageKey, String(Date.now()));
      });

      if (successMessage || isThemeEditor || Date.now() - lastClosed > frequencyMilliseconds) {
        window.setTimeout(openPopup, successMessage || isThemeEditor ? 250 : Number(popup.dataset.delay));
      }

      popup.dataset.initialized = 'true';
    });
  }

  initializeProductNewsletterPopups();
  document.addEventListener('shopify:section:load', (event) => initializeProductNewsletterPopups(event.target));
  document.addEventListener('shopify:section:select', (event) => {
    event.target.querySelector('[data-product-newsletter-popup]')?.showModal();
  });

  } catch(e) { console.error(e); }
})();
})();
